<template>
  <div>
    <el-dialog
      title="系统维护通知"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      show-close
    >
      <div class="maintenance-content">
        <div class="notice-icon">
          <i class="el-icon-warning"></i>
        </div>
        <div class="notice-text">
          <p class="title">系统升级维护</p>
          <p class="info">
            系统将于 <span class="highlight">{{ startDate }}</span> 至 <span class="highlight">{{ endDate }}</span> 进行升级维护。
          </p>
          <p class="info">
            维护期间系统将无法使用，敬请谅解。
          </p>
          <p class="alert">
            <strong>温馨提示：</strong> 请在 <span class="highlight-red">{{ endDate }}</span> 之后再进行相关操作。
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">我已知悉</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceNotice',
  data() {
    return {
      dialogVisible: false,
      // 维护日期
      startDate: '',
      endDate: ''
    };
  },
  methods: {
    handleConfirm() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    // 获取维护时间信息
    async getWarningTime() {
      try {
        let res = await rt.get('../api/DMSMessage/GetWarning_time');
        // 如果返回数据为空，不显示弹窗
        if (!res || res.trim() === '') {
          this.dialogVisible = false;
          return;
        }

        // 按照 , 分割返回值
        let times = res.split(',');
        
        if (times.length >= 2) {
          this.startDate = times[0] ? times[0].trim() : '';
          this.endDate = times[1] ? times[1].trim() : '';
          
          // 如果有有效的时间数据，显示弹窗
          if (this.startDate && this.endDate) {
            this.dialogVisible = true;
          } else {
            this.dialogVisible = false;
          }
        } else {
          this.dialogVisible = false;
        }
      } catch (error) {
        console.error('获取维护时间失败:', error);
        this.dialogVisible = false;
      }
    }
  },
  mounted() {
    // 组件挂载时获取维护时间
    this.getWarningTime();
  }
};
</script>

<style lang="less" scoped>
.maintenance-content {
  display: flex;
  align-items: flex-start;
  padding: 20px 0;

  .notice-icon {
    font-size: 40px;
    color: #e6a23c;
    margin-right: 20px;
    flex-shrink: 0;
    animation: warning-shake 0.5s infinite alternate;
  }

  .notice-text {
    flex: 1;

    p {
      margin: 10px 0;
      font-size: 14px;
      line-height: 1.6;
      color: #333;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
    }

    .info {
      color: #606266;
    }

    .alert {
      background-color: #fdf6ec;
      padding: 12px;
      border-left: 4px solid #e6a23c;
      color: #e6a23c;
      font-size: 13px;
    }

    .highlight {
      color: #409eff;
      font-weight: bold;
    }

    .highlight-red {
      color: #f56c6c;
      font-weight: bold;
    }
  }
}

@keyframes warning-shake {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(3px);
  }
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
}

/deep/ .el-dialog__close {
  color: #909399;
  &:hover {
    color: #606266;
  }
}
</style>



// WEBPACK FOOTER //
// maintenanceNotice.vue?b0fa7aec